import {
  LegalClientEntity,
  LegalClientBeneficiaryEntity,
} from 'api/types/entity';
import { parseFullName } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { usePageTitle } from 'libs/navigation';

export const useBeneficiaryPageTitle = (
  legalClient: LegalClientEntity | null,
  legalClientBeneficiary: LegalClientBeneficiaryEntity | null
) => {
  const { t } = useTranslation();

  let fullName = legalClientBeneficiary
    ? t('client.legal.legalClientBeneficiary.title', {
        name: parseFullName(legalClientBeneficiary),
      })
    : '';

  fullName += fullName && legalClient ? ` - ${legalClient.fullName}` : '';

  usePageTitle(fullName);
};
